export enum EventType {
    PageView = 'page_view',
    CustomEvent = 'custom_event',
  }
  
  export enum TargetType {
    Click = 'click',
    Success = 'success',
    Failure = 'failure',
  }
  export enum PageRoute {
    TaxDocuments = '/tax-documents',
    PensionVerification = '/pension-verification'
  }
  